import { Grid, Typography } from '@mui/material'
import { FileList } from 'components'
import { RichTextEditor } from 'components/richtTextEditor'
import { theme } from 'config'
import { observer } from 'mobx-react'
import { Step } from 'models'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export interface IContentCourseProps {
  step:     Step,
  preview?: boolean,
}

export const ContentCourse = observer((props: IContentCourseProps) => {
  const { step } = props;
  const { t } = useTranslation();

  return (
    <>
        <Grid xs={12} item>
          <Typography textAlign='center' mb={2} variant='h4'>
            {step.title}
          </Typography>
          <StyledRichTextEditor
            disable
            hideToolbar
            transparent
            readOnly = {true}
            value    = {step.getBlocks.join('')}
          />
        </Grid>
        {step.getDocuments.length > 0 && (
          <Grid mt={theme.spacing(4)} item width='100%' xs={12} margin='auto'>
            <FileList files={step.getDocuments} />
          </Grid>
        )}
      </>
  );
});

const StyledRichTextEditor = styled(RichTextEditor)``;
